import auth from 'source/store/auth/index.js';

function checkTrustedPartnerRoute(to, from, next) {
    if (auth.state.user?.user_profile?.is_trusted_partner) {
        next();
    } else {
        next({ name: 'access-denied', replace: true });
    }
}

export default [{
        path: '/scalema',
        component: () =>
            import ('source/pages/root/InternalPageRoot.vue'),
        name: 'scalema-board',
        meta: {
            title: 'Scalema',
            isCompanyIndependent: true,
        },
    children: [{
        path: '',
        name: 'scalema-page-group',
        component: () => import('source/pages/root/ScalemaPageGroup.vue'),
        children: [{
            path: 'scalema-client-workforce-settings',
            name: 'scalema-client-workforce-settings',
            beforeEnter: checkTrustedPartnerRoute,
            component: () =>
                import ('source/pages/scalema/ScalemaClientWorkforceSettingsPage.vue'),
                props: true,
                meta: {
                    title: 'Client Workforce Settings - Scalema',
                    isCompanyIndependent: true,
                },
                children: [
                    {
                        path: 'details',
                        name: 'scalema-client-workforce-details',
                        component: () => import('source/pages/scalema/ScalemaClientWorkforceDetailsPage.vue'),
                        meta: {
                            title: 'Client Workforce - Scalema',
                            canDisplayGlobalModals: true,
                            isInternal: true
                        }
                    },{
                        path: 'invoice',
                        name: 'scalema-client-workforce-new-invoice',
                        component: () => import('source/pages/scalema/ScalemaCreateClientInvoicePage.vue'),
                        meta: {
                            title: 'Client Invoice - Scalema',
                            canDisplayGlobalModals: true,
                            isInternal: true
                        }
                    },{
                        path: 'invoice-details',
                        name: 'scalema-client-workforce-invoice-details',
                        component: () => import('source/pages/scalema/ScalemaClientInvoiceDetailsPage.vue'),
                        meta: {
                            title: 'Client Invoice - Scalema',
                            canDisplayGlobalModals: true,
                            isInternal: true
                        }
                    },{
                        path: 'billing-settings',
                        name: 'scalema-client-workforce-billing-settings',
                        component: () => import('source/pages/scalema/ScalemaBillingSettingsPage.vue'),
                        meta: {
                            title: 'Billing Settings - Scalema',
                            canDisplayGlobalModals: true,
                            isInternal: true
                        }
                    },
                ]
        },{
            path: 'scalema-dashboard',
            name: 'scalema-dashboard',
            component: () =>
                import ('source/pages/scalema/dashboard/ScalemaDashboard.vue'),
            props: true,
            meta: {
                title: 'Scalema - Dashboard',
                isCompanyIndependent: true,
            },
        },
        {
            path: 'scalema-solutions-experts',
            name: 'scalema-solutions-experts',
            component: () =>
                import ('source/pages/scalema/trusted-partners/TrustedPartnersSection.vue'),
            props: true,
            meta: {
                title: 'Scalema Solutions Experts',
                isCompanyIndependent: true,
            },
        },
        {
            path: 'scalema-contract-templates',
            name: 'scalema-contract-templates',
            component: () =>
                import ('source/pages/scalema/ScalemaContractTemplatesPage.vue'),
            props: true,
            meta: {
                title: 'Contract Templates - Scalema',
                isCompanyIndependent: true,
            },
        },
        {
            path: 'scalema-personal-queries',
            name: 'scalema-board-queries',
            component: () =>
                import ('source/pages/scalema/ScalemaBoardPage.vue'),
            props: true,
            meta: {
                title: 'Queries - Scalema',
                isCompanyIndependent: true,
            },
        },
        {
            path: 'scalema-negotiations',
            name: 'scalema-negotiations',
            component: () =>
                import ('source/pages/scalema/ScalemaNegotiationsPage.vue'),
            props: true,
            meta: {
                title: 'Negotiations - Scalema',
                isCompanyIndependent: true,
            },
        },
        {
            path: 'new-query',
            name: 'scalema-board-new-query',
            component: () =>
                import ('source/pages/scalema/ScalemaBoardPage.vue'),
            props: true,
            meta: {
                title: 'New Query - Scalema',
                isCompanyIndependent: true,
            },
        }, {
            path: 'view-contract/:solution_id',
            name: 'scalema-view-contract',
            component: () =>
                import ('source/pages/scalema/ScalemaContractView.vue'),
            props: true,
            meta: {
                title: 'View Contract - Scalema',
                isCompanyIndependent: true,
            },
        }, {
            path: 'negotiations/:thread_id?',
            name: 'scalema-board-negotiations',
            component: () =>
                import ('source/pages/scalema/ScalemaNegotiationsPage.vue'),
            props: true,
            meta: {
                title: 'Negotiations - Scalema',
                isCompanyIndependent: true,
            },
        },{
            path: 'scalema-solutions-expert-board',
            name: 'scalema-tp-board',
            component: () =>
                import ('source/pages/scalema/ScalemaClientQueriesBoardPage.vue'),
            props: true,
            meta: {
                title: 'Client Queries - Scalema',
                isCompanyIndependent: true,
            },
            children: [{
                path: 'approved-queries',
                name: 'scalema-board-approved-queries',
                component: () =>
                    import ('source/pages/scalema/ScalemaClientQueriesBoardPage.vue'),
                props: true,
                meta: {
                    title: 'Approved Queries - Scalema',
                    isCompanyIndependent: true,
                },
            }]
        },
        {
            path: 'send-contract/:proposal_id',
            name: 'scalema-send-contract',
            component: () =>
                import ('source/pages/scalema/ScalemaSendContractPage.vue'),
            props: true,
            meta: {
                title: 'Send Contract - Scalema',
                isCompanyIndependent: true,
            },
        }, {
            path: 'scalema-templates/:action/',
            name: 'scalema-template-maker',
            component: () =>
                import(
                    'source/pages/scalema/ScalemaTemplateMakerPage.vue'
                ),
            props: true,
            meta: {
                title: 'Template Maker - Scalema',
                isCompanyIndependent: true,
                loginRequired: true,
            },
        }, {
            path: 'query-solution/:solutionId',
            name: 'scalema-board-view-solution',
            component: () =>
                import ('source/pages/scalema/ScalemaViewSolutionPageGroup.vue'),
            props: true,
            meta: {
                title: 'View Solution - Scalema',
                isCompanyIndependent: true,
            },
            children: [
                {
                    path: 'negotiation/:thread_id',
                    name: 'negotiation-from-query-solution',
                    component: () =>
                        import ('source/pages/scalema/ScalemaNegotiationsPage.vue'),
                    props: true,
                    meta: {
                        title: 'Negotiation - Scalema',
                        isCompanyIndependent: true,
                    },
                }
            ]
        }, {
            path: 'query-details/:pk',
            name: 'scalema-view-query',
            component: () =>
                import ('source/pages/scalema/ScalemaViewQueryPage.vue'),
            props: true,
            meta: {
                title: 'View Query - Scalema',
                isCompanyIndependent: true,
            },
        },{
            path: 'solutions-generator',
            name: 'scalema-solutions-generator-page',
            component: () =>
                import ('source/pages/scalema/ScalemaSolutionsGeneratorPage.vue'),
            props: true,
            meta: {
                title: 'Solutions Generator Page - Scalema',
                isCompanyIndependent: true,
            },
        }]
    }]
}];
